export default __webpack_public_path__ + "static/media/401a_dark.6d015717.png";